import { useState } from 'react';

export default function ShelvingQuoteTool() {
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [result, setResult] = useState(null);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
  const [customizations, setCustomizations] = useState({});
  const [submittedIndexes, setSubmittedIndexes] = useState([]);

  const calculateQuote = () => {
    const wallWidth = parseFloat(width);
    const wallHeight = parseFloat(height);
    if (isNaN(wallWidth) || isNaN(wallHeight)) return;

    const getMaxRows = (availableHeight) => {
      let rows = 0;
      while (true) {
        const legLength = 2.625 + (rows + 1) * 3.5 + rows * 12.875 + 11.25;
        const totalHeight = legLength + 3;
        if (totalHeight > availableHeight) break;
        rows++;
      }
      return rows;
    };

    const getMaxColumns = (availableWidth, binSpan) => {
      return Math.floor((availableWidth - 1.5) / binSpan);
    };

    const widthwise = {
      orientation: 'Wide View',
      rows: getMaxRows(wallHeight),
      columns: getMaxColumns(wallWidth, 31),
      depth: 19.5,
      binSpan: 31
    };

    const lengthwise = {
      orientation: 'Narrow View',
      rows: getMaxRows(wallHeight),
      columns: getMaxColumns(wallWidth, 22),
      depth: 28.5,
      binSpan: 22
    };

    const calcSpecs = (config) => {
      const { rows, columns, binSpan } = config;
      const width = (columns * binSpan + 1.5).toFixed(2);
      const legLength = 2.625 + rows * 3.5 + (rows - 1) * 12.875 + 11.25;
      const height = (legLength + 3).toFixed(2);
      const bins = rows * columns;

      const runners = bins;
      const topsBottoms = 4;
      const braces = 1;
      const legs = (columns + 1) * 2;

      const screwBox = 26.97;
      const taxRate = 0.12;

      const runnerBoards = config.depth === 28.5 ? Math.ceil(runners / 4) : Math.ceil(runners / 6);
      const legBoards = Math.ceil((legLength * legs) / 120);
      const topBottomBoards = Math.ceil((parseFloat(width) * topsBottoms) / 144);
      const braceBoards = 1;

      const boardPrices = { '96': 4.38, '120': 7.28, '144': 8.68 };
      const matSubtotal = (runnerBoards * boardPrices['120']) + (legBoards * boardPrices['120']) + (topBottomBoards * boardPrices['144']) + (braceBoards * boardPrices['144']) + screwBox;
      const materialCost = Math.round(matSubtotal * (1 + taxRate));

      const basePrice = Math.ceil((materialCost * 2 + 100) / 5) * 5;
      const deposit = Math.ceil(materialCost / 5) * 5;

      return {
        ...config,
        bins,
        width,
        height,
        sectionSplit: parseFloat(width) > 96 ? 'Yes' : 'No',
        basePrice,
        deposit,
        runners,
        imageName: `${rows}x${columns}`,
        fallback: true
      };
    };

    setResult([
      calcSpecs(widthwise),
      calcSpecs(lengthwise)
    ]);
    setSelectedOptionIndex(null);
    setCustomizations({});
    setSubmittedIndexes([]);
  };

  const handleInputChange = (index, key, value) => {
    setCustomizations((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [key]: value
      }
    }));
  };

  const getFallbackImage = (rows, cols) => {
    const cellSize = 20;
    const width = cols * cellSize;
    const height = rows * cellSize;
    const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}'>` +
      [...Array(rows)].map((_, r) =>
        [...Array(cols)].map((_, c) =>
          `<rect x='${c * cellSize}' y='${r * cellSize}' width='${cellSize - 2}' height='${cellSize - 2}' fill='white' stroke='black'/>`
        ).join('')
      ).join('') +
      `</svg>`;
    return `data:image/svg+xml;base64,${btoa(svg)}`;
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
      <h1 style={{ textAlign: 'center' }}>Shelving Quote Tool</h1>

      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <label>Wall Width (in): </label>
        <input value={width} onChange={(e) => setWidth(e.target.value)} type="number" style={{ marginRight: '10px' }} />
        <label>Wall Height (in): </label>
        <input value={height} onChange={(e) => setHeight(e.target.value)} type="number" />
        <div style={{ marginTop: '10px' }}>
          <button onClick={calculateQuote}>Show Options</button>
        </div>
      </div>

      {result && result.map((config, index) => {
        const fallbackSrc = getFallbackImage(config.rows, config.columns);

        return (
          <div key={index} style={{ border: '1px solid #ccc', marginBottom: '20px', padding: '15px' }}>
            <h3>{config.orientation} – <span style={{ fontWeight: 'normal' }}>{config.rows}x{config.columns}</span></h3>
            <img src={`images/${config.imageName}.jpg`} alt={`${config.rows}x${config.columns}`} style={{ width: '250px', display: 'block', margin: '0 auto' }} onError={(e) => e.target.src = fallbackSrc} />
            <div style={{ textAlign: 'left', maxWidth: '500px', margin: '10px auto 0' }}>
              <p><strong>Rack Size:</strong> {config.width}" W × {config.height}" H × {config.depth}" D</p>
              <p><strong>Bins:</strong> {config.bins}</p>
              <p><strong>Section Split Required:</strong> {config.sectionSplit}</p>
              <p><strong>Base Price:</strong> ${config.basePrice}</p>
              <p><strong>Deposit:</strong> ${config.deposit}</p>
              <p><em>Request quote for delivery outside of Abbotsford</em></p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
